<lib-card>
	<div class="w-text-center">
		<h1>
			{{ title() }}
		</h1>
		@if(subtitle(); as subtitle) {
		<div class="push-top-sm" libText3>
			{{ subtitle }}
		</div>
		}
	</div>
	<div class="push-top-md">
		<ng-content></ng-content>
	</div>
</lib-card>
